import { filterRawCatalogProducts } from './catalogProductShape';

const CACHE_PREFIX = 'raheasy_catalog_v2_';
const DEFAULT_TTL_MS = 15 * 60 * 1000;

function sanitizeCacheData(key, data) {
  if (key === 'products' && Array.isArray(data)) {
    return filterRawCatalogProducts(data);
  }
  return data;
}

export function readCatalogCache(key, ttlMs = DEFAULT_TTL_MS) {
  if (typeof sessionStorage === 'undefined') return null;
  try {
    const raw = sessionStorage.getItem(`${CACHE_PREFIX}${key}`);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    const savedAt = Number(parsed?.savedAt) || 0;
    const ttl = Number(parsed?.ttlMs) || ttlMs;
    if (!savedAt || Date.now() - savedAt > ttl) {
      sessionStorage.removeItem(`${CACHE_PREFIX}${key}`);
      return null;
    }
    if (Array.isArray(parsed?.data)) {
      parsed.data = sanitizeCacheData(key, parsed.data);
    }
    return parsed;
  } catch {
    return null;
  }
}

export function writeCatalogCache(key, data, ttlMs = DEFAULT_TTL_MS) {
  if (typeof sessionStorage === 'undefined') return;
  try {
    const payload = sanitizeCacheData(key, data);
    sessionStorage.setItem(
      `${CACHE_PREFIX}${key}`,
      JSON.stringify({ savedAt: Date.now(), ttlMs, data: payload })
    );
  } catch {
    // Quota exceeded or private mode — ignore.
  }
}

export function clearCatalogCache(key) {
  if (typeof sessionStorage === 'undefined') return;
  try {
    sessionStorage.removeItem(`${CACHE_PREFIX}${key}`);
  } catch {
    // ignore
  }
}

/** Drop stale v1 session keys and product cache so refresh never paints deleted items. */
export function clearStaleCatalogSessionCache() {
  if (typeof sessionStorage === 'undefined') return;
  try {
    sessionStorage.removeItem('raheasy_catalog_v1_products');
    sessionStorage.removeItem('raheasy_catalog_v1_categories');
    sessionStorage.removeItem(`${CACHE_PREFIX}products`);
  } catch {
    // ignore
  }
}
